




















































































import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import VueHtml2pdf from 'vue-html2pdf';
import dataList from '@/views/Inspection/InspectionListPage.vue';
import PDFTemplate from '@/components/template/PDFTemplate.vue';
import {Utils} from '@/utils/Utils';

@Component({
  components: {
    VueHtml2pdf,
    dataList,
    PDFTemplate,
  },
})
export default class HtmlToPdfComponent extends Vue {
  @Prop({default: []}) listData!: [];
  @Prop({default: null}) shipDetails!: {};
  @Prop({default: null}) title!: String;

  Utils = Utils;
  header = [
    {
      name: 'S.No',
      value: 'sno',
    },
    {
      name: 'Inspection ID',
      value: 'dataCode',
    },
    {
      name: '#',
      value: 'totalInspections',
      sortable: true,
      headerType: 'number',
      asdcOrder: true,
      filter: true,
    },
    {
      name: 'Ship',
      value: 'shipName',
      sortable: true,
      headerType: 'text',
      asdcOrder: true,
      filter: true,
    },
    {
      name: 'Deck',
      value: 'deckName',
      sortable: true,
      headerType: 'text',
      asdcOrder: true,
      filter: true,
    },

    {
      name: 'Frame',
      value: 'frameNumber',
      sortable: true,
      headerType: 'number',
      asdcOrder: true,
      filter: true,
    },

    {
      name: 'Location',
      value: 'location',
      sortable: true,
      headerType: 'text',
      asdcOrder: true,
      filter: true,
    },
    {
      name: 'Date',
      value: 'dataDate',
      sortable: true,
      headerType: 'date',
      asdcOrder: true,
      filter: true,
    },

    {
      name: 'Inspector',
      value: 'inspectorName',
      sortable: true,
      headerType: 'text',
      asdcOrder: true,
      filter: true,
    },

    {
      name: 'Recipient',
      value: 'recipientUser',
      sortable: true,
      headerType: 'text',
      asdcOrder: true,
      filter: true,
    },

    {
      name: 'Finding',
      value: 'finding',
      sortable: true,
      headerType: 'text',
      asdcOrder: true,
      filter: true,
    },
    {
      name: 'Severity',
      value: 'severity',
      sortable: true,
      headerType: 'text',
      asdcOrder: true,
      filter: true,
    },

    {
      name: 'Voyage',
      value: 'voyageName',
      sortable: true,
      headerType: 'text',
      asdcOrder: true,
      filter: true,
    },
    {
      name: 'Voyage Condition',
      value: 'voyageCondition',
      sortable: true,
      headerType: 'text',
      asdcOrder: true,
      filter: true,
    },
    {
      name: 'Redata Date',
      value: 'redataDate',
      sortable: true,
      headerType: 'date',
      asdcOrder: true,
      filter: true,
    },
    // {name: '#', value: 'status', sortable: false, headerType: 'text'},

    {
      name: 'Work Order',
      value: 'workOrder',
      sortable: true,
      headerType: 'text',
      asdcOrder: true,
      filter: true,
    },
    // {
    //   name: 'Status',
    //   value: 'actionPlanStatus',
    //   sortable: true,
    //   headerType: 'text',
    //   asdcOrder: true,
    //   filter: true,
    // },
    // {name: 'View ', value: 'view'},
    // {name: 'Reinspection', value: 'redata'},

    // {name: 'Locate', value: 'locate'},
  ];

  mounted() {
    //
  }

  async htmlToPdf() {
    //

    const pdfRef: any = this.$refs.html2Pdf;

    const blob = await pdfRef.generatePdf();

    //  const file=await pdfRef.pdfFile
    //
  }
  onProgress(e) {
    if (e === 100) {
      this.$emit('stopLoader');
    }
  }

  hasGenerated(e) {}
}
